import { useState, useEffect, useContext } from "react";
import Axios from "axios";
import StateContext from "../StateContext";
import Skeleton from "@material-ui/lab/Skeleton";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useHistory } from "react-router-dom";
import Page from "./Page";
import LoaderAnimation from "./LoaderAnimation";
import { Button, IconButton } from "@material-ui/core";

// import localizations pakeges
import { withTranslation, useTranslation, Trans } from "react-i18next";
import { handleError } from "../Functions/getAlert";
import DispatchContext from "../DispatchContext";

function Promocodes(props) {
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext)
  const [allPromoCodes, setAllPromoCodes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [seeMore, setSeeMore] = useState(5)
  let history = useHistory();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_API_URL}customer/promocode`,
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );
        // console.log(response.data.data,"gert dskfjaskldj")
        setAllPromoCodes(response.data.data);
        props.setCount(response.data.data.length);
        // appDispatch({type: "DetailsAdd", allDetails: response.data.data, loading: false})
        setIsLoading(false);
      } catch (e) {
        Promise.reject(e);
        handleError(e, appDispatch)
      }
    };
    fetchData();
  }, []);

  
  const handleSeeMore = () => {
    let count = seeMore + 5
  if(count < allPromoCodes.length ){
    setSeeMore(count)
  }else if(count > allPromoCodes.length ){
    setSeeMore(allPromoCodes.length)
  }
}
  if (!appState.loggedIn) {
    history.push("/");
  }
  if (isLoading)
    return (
      
      <div style={{ position: "relative", height: "250px" }}>
        {/* <div className="circularLoading"> */}
          <LoaderAnimation />
        {/* </div> */}
        {/* <div className="circularLoading"><CircularProgress /></div> */}
      </div>
    );
  if (allPromoCodes.length > 0) {
    return (
      <Page title="Promocodes">
        {/* activities */}
        <div className="activities mt-4">
          <div className="activitiesHead mb-4">
            <h4 className="text-secondary">Activities</h4>
          </div>
          {/* activity__row */}
          {allPromoCodes.map((promo) => (
            
            <ActivityRow key={promo.id} promos={promo} />
            
          ))}
            <div className="col-12 d-flex justify-content-center mb-2">
          { seeMore < allPromoCodes.length ?  <Button
              variant="text"
              onClick={handleSeeMore}
            >
              {" "}{"See More"}{" "}
            </Button>
            : ""
}            </div>
        </div>
      </Page>
    );
  } else {
    return (
      <Page title="Promocodes">
             <div className="empBox">
          <div className="text-center py-5">
            {/* BoxImg */}
            <div className="BoxImg">
              <img
                src={`${process.env.REACT_APP_IMAGE_URL}box.png`}
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="mt-1">
              <p className="text-secondary">
                <strong>{t("status.promo-not-found")}</strong>
              </p>
            </div>
          </div>
        </div>
              </Page>
    );
  }
}

function ActivityRow(props) {
  let dateUsed = props.promos.created_at.split(" ")[0];
  const {t} = useTranslation()
  return (
    <div
      className="activity__row row m-0 align-items-center justify-content-between"
      id={"promocode-" + props.promos.id}
    >
      <div className="row m-0 justify-content-center align-items-center">
        <p className="text-secondary px-1">
          <strong>Order Number:</strong>
        </p>
        <p className="text-primary px-1"> {props.promos.order_invoice_id}</p>
      </div>
      <div className="row m-0 justify-content-center align-items-center">
        <p className="text-secondary px-1">
          <strong>Code:</strong>
        </p>
        <p className="text-primary px-1"> {props.promos.promocode}</p>
      </div>
      <div className="row m-0 justify-content-center align-items-center">
        <p className="text-secondary px-1">
          <strong>Discount:</strong>
        </p>
        <p className="text-primary px-1"> {props.promos.amount} {t("KWD")}</p>
      </div>
      <div className="row m-0 justify-content-center align-items-center">
        <p className="text-secondary px-1">
          <strong>Date Used:</strong>
        </p>
        <p className="text-primary px-1"> {dateUsed}</p>
      </div>
    </div>
  );
}

export default withTranslation()(Promocodes);
